export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const calculateRelativeMousePosition = (
  mouseX: number,
  mouseY: number,
  astroX: number,
  astroY: number,
) => {
  const relativeX = mouseX - astroX;
  const relativeY = mouseY - astroY;

  const lookRange = 30;

  const normalizedX = Math.max(
    0,
    Math.min(100, 50 - (relativeX / lookRange) * 50),
  );
  const normalizedY = Math.max(
    0,
    Math.min(100, 50 - (relativeY / lookRange) * 50),
  );

  return { x: normalizedX, y: normalizedY };
};

export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number,
): ((...args: Parameters<T>) => void) => {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return (...args: Parameters<T>) => {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => func(...args), wait);
  };
};
